// COMPONENTS
import { VscDebugStackframeDot } from 'react-icons/vsc'
import { HiOutlineChevronRight } from 'react-icons/hi'
import { RiShapeLine } from 'react-icons/ri'
// STYLES & ASSETS
import styles from './AccountDetails.module.scss'
import GTBank from '../../assets/images/icon_gtbank.png'
import { Link } from 'react-router-dom'

const AccountDetails = () => {
	return (
		<aside className={styles.AccountDetails}>
			<div className={styles.AccountDetailsHeader}>
				<h4 className={styles.AccountDetailsHeaderTitle}>
					Activity Feed <span className={styles.textFade}> - GT Bank</span>
				</h4>
				<small className={`${styles.AccountCreatedTime} ${styles.textFade}`}>
					<span className={styles.textActive}>Active</span>
					<span>
						<VscDebugStackframeDot />
						Created 16days ago
					</span>
				</small>
			</div>

			<div className={styles.AccountDetailsSummary}>
				<img src={GTBank} alt="GT-Bank" />

				<div className={styles.AccountDetailsSummaryD}>
					<div className={styles.BankSummary}>
						<h4 className={styles.AccountDetailsSummaryBankName}>
							Guaraty Trust Bank
						</h4>
						<p className={styles.textFade}>209630**83</p>
					</div>
					<Link to={'#'} className={styles.AccountDetailsSummaryLink}>
						<span>Go to Account View</span>
						<HiOutlineChevronRight
							className={`${styles.textPurple} ${styles.chevronRight}`}
						/>
					</Link>
				</div>

				<div className={styles.AccountActivitySummary}>
					<div className={styles.ActivityInflow}>
						<small className={styles.ActivitySummaryTitle}>Total Inflow</small>
						<p className={styles.ActivitySummaryText}>₦77,823.00</p>
					</div>
					<div className={styles.ActivityDate}>
						<small className={styles.ActivitySummaryTitle}>
							Last Activity Date
						</small>
						<p className={styles.ActivitySummaryText}>13th Sept. 2022</p>
					</div>
					<div className={styles.ActivityBranch}>
						<small className={styles.ActivitySummaryTitle}>
							{' '}
							Linked Branch
						</small>
						<div className={styles.BankBranch}>
							<RiShapeLine />
							<small className={styles.BankBranchName}>Dodo - Lekki II</small>
						</div>
					</div>
				</div>

				<div className={styles.TransactionList}>
					<div className={styles.TransactionListTitles}>
						<p>Transaction Details</p>
						<p>Amount</p>
						<p>Date</p>
					</div>

					<div className={styles.TransactionListItem}>
						<p>Olaoluwa S.</p>
						<p>₦6,720.00</p>
						<p className={styles.AccountDetailsLink}>
							<span>Today, 8mins ago</span> <HiOutlineChevronRight />
						</p>
					</div>

					<div className={`${styles.TransactionListItem} ${styles.active}`}>
						<p>Olaoluwa S.</p>
						<p>₦6,720.00</p>
						<p className={styles.AccountDetailsLink}>
							<span>13th Aug - 3:15PM</span> <HiOutlineChevronRight />
						</p>
					</div>

					<div className={styles.TransactionListItem}>
						<p>Olaoluwa S.</p>
						<p>₦6,720.00</p>
						<p className={styles.AccountDetailsLink}>
							<span>13th Aug - 3:15PM</span> <HiOutlineChevronRight />
						</p>
					</div>

					<div className={styles.TransactionListItem}>
						<p>Olaoluwa S.</p>
						<p>₦6,720.00</p>
						<p className={styles.AccountDetailsLink}>
							<span>13th Aug - 3:15PM</span> <HiOutlineChevronRight />
						</p>
					</div>

					<div className={`${styles.TransactionListItem} ${styles.noBorder}`}>
						<p>Olaoluwa S.</p>
						<p>₦6,720.00</p>
						<p className={styles.AccountDetailsLink}>
							<span>13th Aug - 3:15PM</span> <HiOutlineChevronRight />
						</p>
					</div>
				</div>
			</div>
		</aside>
	)
}

export default AccountDetails
